import angular from 'angular';
import moment from 'moment';
import { ApuracoesPontoService } from '../apuracoesponto.service';
import { ConfiguracoesService } from '../../../../Configuracoes/configuracoes.service';
import { PagamentosPontoService } from '../../Pagamentos/pagamentos.service';
import { FolhasdePontoService } from '../../FolhasDePonto/folhasdeponto.service';
import { IApuracaoPonto } from './../../models/apuracaoponto.model';
import { IApuracaoProcessamento } from '../../models/apuracaoprocessamento.model';

export class ApuracaoPontoController implements angular.IController {

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'ModalConfirmService',
        'PagamentosPontoService',
        'FolhasdePontoService',
        'NewToaster',
        'ConfiguracoesService',
    ];

    public entities: Array<IApuracaoPonto>;
    public apuracoesPontoService: ApuracoesPontoService;
    public busy: boolean;
    public nomeArquivoDownload: string = '';
    public prefixoArquivo = 'folhasponto-';
    public apuracaoHistoricoSelecionada: IApuracaoPonto | null = null;
    public historicoAberto = false;
    public historicoRefreshKey = 0;
    private sincronizarHistoricoNoProximoReload = false;
    private configuracoesLoaded: boolean = false;
    private bloquearApuracoesAjustesPendentes: boolean = false;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            configuracoes: any,
            session: any
        },
        public $state: angular.ui.IStateService,
        public ModalConfirmService: any,
        public PagamentosPontoService: PagamentosPontoService,
        public FolhasPontoService: FolhasdePontoService,
        public NewToaster: any,
        public ConfiguracoesService: ConfiguracoesService,
    ) {
        this.ConfiguracoesService.reload();

        $scope.$on('configuracoes_list_finished', (_event: angular.IAngularEvent, args: any) => {
            const config = args?.BLOQUEAR_APURACOES_AJUSTES_PENDENTES;
            const valor = config && typeof config === 'object' && 'valor' in config ? config.valor : config;
            this.bloquearApuracoesAjustesPendentes =
                valor === true || valor === 'true' || valor === 1 || valor === '1';
            this.configuracoesLoaded = true;
        });

        $rootScope.$on('apuracoesponto_fechado', (event: angular.IAngularEvent, args: any) => {
            this.atualizaApuracao(args);
            this.recarregarHistoricoSelecionado(args?.data?.apuracaoponto);
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'A apuração de ponto foi fechada com sucesso!',
            });
        });

        $rootScope.$on('apuracoesponto_fechar_erro', (_event: angular.IAngularEvent, err: any) => {
            this.busy = false;
            const message = err?.data?.message;
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível fechar a apuração.',
                body: typeof message === 'string' && message.trim() ? message : undefined,
            });
        });

        $rootScope.$on('apuracoesponto_reaberto', (event: angular.IAngularEvent, args: any) => {
            this.atualizaApuracao(args);
            this.recarregarHistoricoSelecionado(args?.data?.apuracaoponto);
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'A apuração de ponto foi reaberta com sucesso!',
            });
        });

        $rootScope.$on('apuracoesponto_reabrir_erro', (err: any) => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Pagamentos já foram efetuados para essa apuração de ponto! Não é possível reabrir a apuração!',
            });
        });

        $scope.$on('apuracoesprocessamento_iniciaprocessamentofolhas_iniciado', (event, args: any) => {
            this.atualizaApuracaoProcessamento(args);
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                body: `As folhas de ponto foram enviadas para processamento.
                    Uma notificação será enviada para o seu e-mail assim que for concluído.`,
            });
        });

        $scope.$on('apuracoesprocessamento_iniciaprocessamentofolhas_erro', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao gerar as folhas de ponto.',
            });
        });

        $scope.$on('ponto_apuracoesponto_gerar_previa_iniciado', (event, args: any) => {
            this.atualizaApuracaoProcessamentoPrevia(args);
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                body: `A prévia das folhas de ponto foram enviadas para processamento.
                    Uma notificação será enviada para o seu e-mail assim que for concluído.`,
            });
        });

        $scope.$on('ponto_apuracoesponto_gerar_previa_erro', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao gerar a prévia das folhas de ponto.',
            });
        });

        $scope.$on('apuracoesprocessamento_downloadfolhaslote_sucesso', (event: angular.IAngularEvent, args: any) => {
            this.trataDownload(args.data);
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'Download realizado com sucesso!',
            });
        });

        $rootScope.$on('apuracoesprocessamento_downloadfolhaslote_erro', (err: any) => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro no download.',
            });
        });

        $rootScope.$on('apuracoesponto_regerarpagamentos_iniciado', (event: angular.IAngularEvent, args: any) => {
            this.atualizaApuracao(args);
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'Os pagamentos foram gerados com sucesso!',
                // body: 'Os relatórios foram enviados para a fila de processamento. Uma notificação será enviada para o seu e-mail assim que for concluído.',
            });
        });

        $rootScope.$on('apuracoesponto_regerarpagamentos_erro', (err: any) => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao gerar os pagamentos.',
            });
        });

        $scope.$watch('$ctrl.entities', (newValue: any, oldValue: any): void => {
			if (newValue !== oldValue) {
                this.getAccordionTitles();
			}
		}, true);

        $scope.$on('apuracoesponto_index_manual_refresh_started', () => {
            this.sincronizarHistoricoNoProximoReload = true;
        });

        $scope.$on('apuracoesponto_index_loaded', () => {
            if (!this.sincronizarHistoricoNoProximoReload) {
                return;
            }

            this.sincronizarHistoricoNoProximoReload = false;
            this.sincronizarHistoricoAposReload();
        });

        $scope.$on('apuracoesponto_index_error', () => {
            this.sincronizarHistoricoNoProximoReload = false;
        });
    }

    $onInit() {
        this.getAccordionTitles();
    }

    getAccordionTitles() {
        this.entities.forEach((element: IApuracaoPonto) => {
            const inicioapuracao = moment(element.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
            const terminoapuracao = moment(element.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
            element['titleaccordion'] = 'Apuração ' + inicioapuracao + ' a ' + terminoapuracao + this.getReferenciaApuracao(element);
            if (element.lastupdate) {
                const recalculo = moment(element.lastupdate, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
                element['subtitleaccordion'] = 'Último recálculo em ' + recalculo;
            }
            this.verificaDataApuracao(element);
            element.isapuracaoatual = this.isApuracaoAtual(element);
        });
    }

    getReferenciaApuracao(apuracao: IApuracaoPonto) {
        if (apuracao.trabalhadorobj?.trabalhador) {
            return ` - Trabalhador: ${apuracao.trabalhadorobj.nome} `;
        }
        if (apuracao.lotacaoobj?.lotacao) {
            return ` - Lotação: ${apuracao.lotacaoobj.nome} `;
        }
        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return ` - Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia} `;
        }
        if (apuracao.empresaobj?.empresa) {
            return ` - Empresa: ${apuracao.empresaobj.razaosocial} `;
        }
        return ' ';
    }

    atualizaApuracao(args: any) {
        let updatedEntity: IApuracaoPonto | null = null;
        for (let i = 0; i < this.entities.length; i++) {
            if (!updatedEntity && this.entities[i].apuracaoponto === args.data.apuracaoponto) {
                this.entities[i] = angular.copy(args.data);
                updatedEntity = this.entities[i];
            }
        }
        this.getAccordionTitles();

        if (
            updatedEntity &&
            this.apuracaoHistoricoSelecionada &&
            this.apuracaoHistoricoSelecionada.apuracaoponto === updatedEntity.apuracaoponto
        ) {
            this.apuracaoHistoricoSelecionada = updatedEntity;
        }
    }

    atualizarProcessamento(apuracaoponto: string, processamento: IApuracaoProcessamento) {
        const entity = this.entities.find(e => e.apuracaoponto === apuracaoponto);

        if (entity) {
            entity.apuracaoprocessamento = angular.copy(processamento);
        }

        this.getAccordionTitles();
    }

    atualizaApuracaoProcessamentoPrevia(args: any) {
        this.atualizarProcessamento(
            args.data.apuracaoponto,
            args.data.apuracaoprocessamento
        );
    }

    atualizaApuracaoProcessamento(args: any) {
        this.atualizarProcessamento(
            args.data.apuracaoponto.apuracaoponto,
            args.data
        );
    }

    download(apuracao: IApuracaoPonto): void {
        this.busy = true;
        this.nomeArquivoDownload = '';
        let inicioapuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('DD-MM-YYYY');
        let terminoapuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('DD-MM-YYYY');
        this.nomeArquivoDownload = this.prefixoArquivo + inicioapuracao + '-a-' + terminoapuracao;
        this.apuracoesPontoService.download(apuracao);
    }

    abrirHistorico(apuracao: IApuracaoPonto) {
        this.apuracaoHistoricoSelecionada = apuracao;
        this.historicoAberto = true;
    }

    fecharHistorico() {
        this.historicoAberto = false;
        this.apuracaoHistoricoSelecionada = null;
    }

    carregarMais(): void {
        if (this.busy || this.apuracoesPontoService.loadParams.busy || this.apuracoesPontoService.loadParams.finished) {
            return;
        }

        this.busy = true;
        this.apuracoesPontoService.loadMore(1);
    }

    fechar(apuracao: IApuracaoPonto): void {
        let dataHoje = new Date();
        if (moment(dataHoje).isAfter(apuracao.terminoapuracao, 'day')) {
            this.busy = true;
            this.apuracoesPontoService.fechar(apuracao);
        } else {
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível fechar a apuração.',
                body: 'Não é possível fechar uma apuração cuja data de término (' + moment(apuracao.terminoapuracao).format('DD/MM/YYYY') + ') seja igual ou posterior a data de hoje (' + moment(dataHoje).format('DD/MM/YYYY') + ').',
            });
        }
    }

    reabrir(apuracao: IApuracaoPonto): void {
        this.busy = true;
        this.apuracoesPontoService.reabrir(apuracao);
    }

    fecharConfirm(apuracao: IApuracaoPonto): void {
        let inicioapuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        let terminoapuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        let textos = {
            title: 'Fechar Apuração',
            subtitle: 'Após fechar a apuração, os colaboradores não poderão fazer alterações em seus pontos. Além disso serão geradas suas folhas de ponto e a prévia de seus pagamentos, sendo que essa última, ainda irá requerer uma liberação para que seja de fato disponibilizada.',
            confirmText: 'Você tem certeza que deseja fechar a apuração de ' + inicioapuracao + ' a ' + terminoapuracao + '? Após sua confirmação, os itens supracitados irão para uma fila de processamento, e após a conclusão, você será notificado por email e poderá acessá-los. ',
            confirmTextNum: '',
            closeButton: 'Cancelar',
            confirmButton: 'Sim, fechar apuração',
        };
		let confirm = this.ModalConfirmService.open(apuracao, 'Apuração', false, textos);

        confirm.result.then((): void => {
            this.fechar(apuracao);
        })
        .catch((error: any): void => {
            if (error !== 'backdrop click' && error !== 'cancelar' && error !== 'escape key press') {
                this.NewToaster.pop({
                    type: 'error',
                    title: error
                });
            }
        });
    }

    isBloqueioAjustesPendentesAtivo(): boolean {
        if (!this.configuracoesLoaded) {
            return false;
        }
        return this.bloquearApuracoesAjustesPendentes;
    }

    reabrirConfirm(apuracao: IApuracaoPonto): void {
        let inicioapuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        let terminoapuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        let textos = {
            title: 'Reabrir Apuração',
            subtitle: 'Ao reabrir a apuração, alterações poderão ser feitas nos pontos dos colaboradores, e as folhas de ponto e as prévias de pagamentos gerados anteriormente serão descartadas.',
            confirmText: 'Você tem certeza que deseja reabrir a apuração de ' + inicioapuracao + ' a ' + terminoapuracao + ' ',
            confirmTextNum: '',
            closeButton: 'Cancelar',
            confirmButton: 'Sim, reabrir apuração',
        };
		let confirm = this.ModalConfirmService.open(apuracao, 'Apuração', false, textos);

        confirm.result.then((): void => {
            this.reabrir(apuracao);
        })
        .catch((error: any): void => {
            if (error !== 'backdrop click' && error !== 'cancelar' && error !== 'escape key press') {
                this.NewToaster.pop({
                    type: 'error',
                    title: error
                });
            }
        });
    }

    trataDownload(data: any): void {
        var blob = new Blob([data]);
        let fileURL = (window.URL || window.webkitURL).createObjectURL(blob);
        var a = document.createElement('a');

        let nomeArquivo = '';
        nomeArquivo = this.nomeArquivoDownload + '.zip';

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = nomeArquivo;
        a.click();
        window.URL.revokeObjectURL(fileURL);
    }

    goToAnalises(entity: IApuracaoPonto): void {
        this.$state.go('analisesponto', {'apuracaoponto': entity.apuracaoponto});
    }

    gerarPreviaDasFolhas(entity: IApuracaoPonto) {
        this.busy = true;
        this.FolhasPontoService.gerarPreviaDasFolhas(entity);
    }

    gerarFolhasdeponto(entity: IApuracaoPonto) {
        this.busy = true;
        this.FolhasPontoService.gerarFolhas(entity);
    }

    regerarFolhasdeponto(apuracao: IApuracaoPonto, previa: boolean = false) {
        const inicioapuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const terminoapuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const textos = {
            title: 'Gerar novamente',
            confirmText: `Você tem certeza que deseja gerar novamente
                os relatórios da apuração de ${inicioapuracao} a ${terminoapuracao}?`,
            closeButton: 'Cancelar',
            confirmButton: 'Sim, gerar novamente',
        };

		this.ModalConfirmService.open(apuracao, 'Apuração', false, textos).result
            .then(() => {
                previa ? this.gerarPreviaDasFolhas(apuracao) : this.gerarFolhasdeponto(apuracao);
            }).catch(() => {/**/});
    }

    gerarPagamentos(entity: IApuracaoPonto): void {
        this.busy = true;
        this.PagamentosPontoService.regerarPagamentos(entity.apuracaoponto);
    }

    verificaDataApuracao(apuracao: IApuracaoPonto): void {
        let dataAtual = moment().format('YYYY-MM');
        let dataAtualMenosUmMes = moment().subtract(1, 'month').format('YYYY-MM');

        // verifica se existe algum periodo com um mes anterior ao mes da data atual ou no mesmo mes
        if (dataAtualMenosUmMes === moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('YYYY-MM') || dataAtualMenosUmMes === moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('YYYY-MM')) {
            apuracao.initopenaccordion = true;
        } else if (dataAtual === moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('YYYY-MM') || dataAtual === moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('YYYY-MM')) {
            apuracao.initopenaccordion = true;
        } else {
            apuracao.initopenaccordion = false;
        }
    }

    isApuracaoAtual(apuracao: IApuracaoPonto) {
        const dataHoje = moment().startOf('day');
        const inicioApuracao = moment(apuracao.inicioapuracao).startOf('day');
        const terminoApuracao = moment(apuracao.terminoapuracao).endOf('day');

        if (!inicioApuracao.isValid() || !terminoApuracao.isValid()) {
            return false;
        }

        return dataHoje.isBetween(inicioApuracao, terminoApuracao, undefined, '[]');
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }

    private recarregarHistoricoSelecionado(apuracaoponto?: string) {
        if (
            !this.historicoAberto ||
            !this.apuracaoHistoricoSelecionada?.apuracaoponto ||
            !apuracaoponto ||
            this.apuracaoHistoricoSelecionada.apuracaoponto !== apuracaoponto
        ) {
            return;
        }

        this.historicoRefreshKey++;
    }

    private sincronizarHistoricoAposReload() {
        if (!this.historicoAberto || !this.apuracaoHistoricoSelecionada?.apuracaoponto) {
            return;
        }

        const apuracaoAtualizada = this.entities.find((entity) => (
            entity.apuracaoponto === this.apuracaoHistoricoSelecionada?.apuracaoponto
        ));

        if (!apuracaoAtualizada) {
            this.fecharHistorico();
            return;
        }

        this.apuracaoHistoricoSelecionada = apuracaoAtualizada;
        this.historicoRefreshKey++;
    }
}
